import React from 'react';
import { components } from "react-select";

const EnquiryNoOptionsMessage = (props) => {
    const { selectRef, HandleShowNew, Name, Master } = props;
    return (
        <>
            <components.NoOptionsMessage {...props}>
                <div>
                    <h5 className="dropdown-h5 mb-3">
                        The {Name} did not match with any options
                    </h5>
                    <span>
                        <button
                            type="button"
                            className="btn continue-here-btn mr-2"
                            onClick={() => selectRef?.current?.blur()}
                        >
                            Continue Here
                        </button>

                        <button type="button" className="btn add-master-btn" onClick={HandleShowNew}>
                            Add to {Master} </button>
                    </span>
                </div>
            </components.NoOptionsMessage>

        </>
    )
}

export default EnquiryNoOptionsMessage 